import * as React from 'react'
import { useContext } from 'react'
import { NextPage } from 'next'
import Menu from 'material-ui-popup-state/HoverMenu'
import MenuItem from '@mui/material/MenuItem'
import { bindHover, bindMenu, usePopupState } from 'material-ui-popup-state/hooks'
import { logout } from '@/lib/hocs/withAuthSync'
import getRoutes from '@/lib/getRoutes'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { useMediaQuery, useTheme } from '@mui/material'
import Link from '@/components/Common/Link'
import isAdmin from '@/lib/isAdmin'
import ProfileContext from '@/components/Context/ProfileContext'

type Props = {
  children: any
  authenticate: boolean
}

const MenuPopupState: NextPage<Props> = ({ children, authenticate }) => {
  const router = useRouter()
  const { locale } = useIntl()
  const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' })
  const theme = useTheme()
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))

  const { profile } = useContext(ProfileContext)

  const handleLogout = async (e: any) => {
    e.stopPropagation()
    e.persist()
    popupState.close
    await logout({ locale })
  }
  const urlSubmitDashboard = getRoutes({ route: 'Dashboard' })
  const urlSubmitOrder = getRoutes({ route: 'Order' })

  return (
    <>
      {downSM ? <>{children}</> : <div {...bindHover(popupState)}>{children}</div>}

      {authenticate ? (
        <Menu
          {...bindMenu(popupState)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem
            className={urlSubmitDashboard.href === router.pathname ? 'border-l-4 border-secondary-main' : ''}
          >
            <Link route={'Dashboard'}>{t({ id: 'web_mon_compte' })}</Link>
          </MenuItem>
          <MenuItem
            className={urlSubmitOrder.href === router.pathname ? 'border-l-4 border-secondary-main' : ''}
          >
            <Link route={'Order'}>{t({ id: 'web_liste_de_mes_commandes' })}</Link>
          </MenuItem>
          <MenuItem>
            <Link route={'PurchaseManage'}>{t({ id: 'web_espace_last_purchase' })}</Link>
          </MenuItem>
          <MenuItem>
            <Link route={'Wishlist'}>{t({ id: 'web_espace_list_favori' })}</Link>
          </MenuItem>
          <MenuItem>
            <Link route={'RecentProducts'}>{t({ id: 'web_derniers_produits_consultes' })}</Link>
          </MenuItem>
          {isAdmin(profile) && (
            <MenuItem>
              <Link href={'/admin/import-customers'}>Importer des pharmacies</Link>
            </MenuItem>
          )}
          <MenuItem onClick={handleLogout}>{t({ id: 'web_logout' })}</MenuItem>
        </Menu>
      ) : (
        <Menu
          {...bindMenu(popupState)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem>
            <Link route={'LoginRedirect'}>{t({ id: 'web_je_m_identifie' })}</Link>
          </MenuItem>
        </Menu>
      )}
    </>
  )
}

export default MenuPopupState
